import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  PageFooterElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer } from "@easy-email-pro-core/components";
import { Element } from "slate";

const defaultData: ElementDefinition<PageFooterElement>["defaultData"] = {
  attributes: {
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
  },
  data: {
    content: [],
    editable: false,
  },
};

export const PageFooter = createBlock<PageFooterElement>({
  get name() {
    return t("Footer");
  },
  void: true,
  defaultData,
  type: BasicType.PAGE_FOOTER,
  create: (payload) => {
    const data: PageFooterElement = {
      type: BasicType.PAGE_FOOTER,
      data: {
        ...defaultData.data,
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(data, payload);
  },
  get category() {
    return ElementCategory.PAGE_FOOTER;
  },
  render(params) {
    const wrapNode = {
      ...params.node,
      type: BasicType.WRAPPER,
      attributes: {
        ...params.node.attributes,
      },
    };
    return (
      <BlockRenderer {...params} node={wrapNode}>
        {params.node.data.content.map((child) => {
          return (
            <BlockRenderer key={child.id} {...params} node={child as Element} />
          );
        })}
      </BlockRenderer>
    );
  },
});
